export default "__VITE_ASSET__BUDOBsCA__"